//@flow

import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';

type Props = {
  children: React$Node,
  title: string,
  subtitle?: string,
  badgeLabel?: string,
  subtitleLeftContend?: React$Node,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.grey1000,
  },
  subtitle: {
    fontSize: '14px',
    color: colors.grey800,
  },
  subtitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  badge: {
    fontSize: '12px',
    color: colors.grey800,
    fontWeight: 600,
    textTransform: 'uppercase',
    padding: '.25rem .5rem',
    borderRadius: '12px',
    background: colors.grey300,
    width: 'fit-content',
  },
}));

export default function FormSection(props: Props) {
  const {children, title, badgeLabel, subtitle, subtitleLeftContend} = props;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <header className={classes.infoSection}>
        <Typography className={classes.title}>{title}</Typography>
        {subtitle && (
          <div className={classes.subtitleContainer}>
            <Typography className={classes.subtitle}>{subtitle}</Typography>
            {subtitleLeftContend && subtitleLeftContend}
          </div>
        )}
        {badgeLabel && <span className={classes.badge}>{badgeLabel}</span>}
      </header>
      {children}
    </div>
  );
}
